export default {
	INSURANCE: 'companies/:company_id/insurance/',
	INSURANCE_SEARCH: 'companies/:company_id/insurance/search',
	FREE_COVERAGE: 'companies/:company_id/free-insurance',
	FREE_COVERAGE_PROPERTY: 'companies/:company_id/properties/',
	COVERAGE_OPTIONS: 'companies/:company_id/insurance-templates',
}
